import { isAxiosError } from "axios";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useAsync } from "react-use";
import { useAuth, useMessage } from "@/contexts";
import {
  TransferCategory,
  TransferCreate,
  TransferService,
} from "@/domains/transfer";
import { UserCategory, UserService } from "@/domains/user";
// components
import { Button, Form, Input, Select, Spin } from "antd";

export const OperatorManageCreateCustomDepositPage = () => {
  const { t } = useTranslation();

  const auth = useAuth();

  const { messageApi } = useMessage();

  const [form] = Form.useForm<TransferCreate>();

  const [loading, setLoading] = useState(false);

  const [belongs, setBelongs] = useState<{ id: string; name: string }[]>([]);

  const { loading: belongsLoading } = useAsync(async () => {
    if (!auth.user) return;

    const isAccount = auth.user.category === UserCategory.TenantAccount;
    const parentId = isAccount ? auth.user.id : auth.user.parent_id!;

    const res = await UserService.list({
      parent_id: parentId,
      category: UserCategory.TenantAccount,
    }).run();

    setBelongs(res.data.msg.users);
  });

  const handleFinish = async (values: TransferCreate) => {
    try {
      setLoading(true);
      await TransferService.create({
        ...values,
        category: TransferCategory.ManualAdd,
        currency: "USDT",
      }).run();
      void messageApi.success(t("systems.Modal.customDepositCreated"));
      form.resetFields();
    } catch (e) {
      if (isAxiosError(e)) {
        void messageApi.error(e.response?.data.msg as string);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w:500 p:16 bg:white r:4 mt:0 mb:0 ml:auto mr:auto">
      <h4 className="mb:24 t:center fg:secondary">
        {t("systems.Menu.applyCustomDeposit")}
      </h4>

      <Form form={form} labelCol={{ span: 5 }} onFinish={handleFinish}>
        <Form.Item
          label={t("domains.Transfer.belong")}
          name="user_id"
          rules={[
            {
              required: true,
              message: t("systems.Error.cannotBeEmpty", {
                field: t("domains.Transfer.belong"),
              }),
            },
          ]}
        >
          <Select
            allowClear
            notFoundContent={belongsLoading ? <Spin size="small" /> : null}
            placeholder={t("systems.Placeholder.pleaseSelect", {
              field: t("domains.Transfer.belong"),
            })}
            options={belongs.map((belong) => ({
              label: belong.name,
              value: belong.id,
            }))}
          />
        </Form.Item>

        <Form.Item
          label={t("domains.Transfer.depositUnit")}
          rules={[{ required: true }]}
          name="amount"
        >
          <Input
            type="number"
            placeholder={t("systems.Placeholder.pleaseInput", {
              field: t("domains.Transfer.depositUnit"),
            })}
          />
        </Form.Item>

        <Form.Item label={t("domains.Transfer.note")} name="note">
          <Input
            placeholder={t("systems.Placeholder.pleaseInput", {
              field: t("domains.Transfer.note"),
            })}
          />
        </Form.Item>

        <div className="flex jc:center gap:16">
          <Button type="primary" htmlType="submit" loading={loading}>
            {t("systems.Action.submit")}
          </Button>

          <Button htmlType="reset">{t("systems.Action.clear")}</Button>
        </div>
      </Form>
    </div>
  );
};
